export default __webpack_public_path__ + "static/media/logo-omni.4da16a14.png";